import { atom } from "@reatom/core"

import { Psychologist } from "utils/interfaces"

export const profilesCachedAtom = atom<Record<string, Psychologist[]>>({})
